import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchRuns } from "../api.js";
import StatusBadge from "../components/StatusBadge.jsx";

function formatDuration(startedAt, completedAt) {
  if (!startedAt || !completedAt) return "—";
  try {
    const a = new Date(startedAt).getTime();
    const b = new Date(completedAt).getTime();
    return `${Math.round((b - a) / 1000)}s`;
  } catch {
    return "—";
  }
}

export default function ServiceDetail() {
  const { serviceName } = useParams();
  const [data, setData] = useState({ runs: [] });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const j = await fetchRuns(serviceName);
        if (!cancelled) setData(j);
      } catch (e) {
        if (!cancelled) setError(String(e.message || e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [serviceName]);

  if (loading) return <p>Loading runs…</p>;
  if (error) return <div className="error">{error}</div>;

  const runs = data.runs || [];

  return (
    <>
      <p>
        <Link to="/">← Services</Link>
      </p>
      <h1>{decodeURIComponent(serviceName)}</h1>
      <table>
        <thead>
          <tr>
            <th>Started</th>
            <th>Revision</th>
            <th>Env</th>
            <th>Status</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {runs.map((r) => (
            <tr key={r.runId}>
              <td>{r.startedAt || "—"}</td>
              <td>
                <Link to={`/runs/${encodeURIComponent(r.runId)}`}>
                  {(r.revision || "").slice(0, 7)}
                </Link>
              </td>
              <td>{r.environment || "—"}</td>
              <td>
                <StatusBadge status={r.status} />
              </td>
              <td>{formatDuration(r.startedAt, r.completedAt)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {runs.length === 0 && <p style={{ color: "#71767b" }}>No runs yet.</p>}
    </>
  );
}
